import React from 'react';
import SectionTitle from '../../../components/section-title';
import Accordion from '../../../components/accordion';
import Exploration from '../../../content/overview/what-do-we-do/exploration';
import AssetDevelopment from '../../../content/overview/what-do-we-do/asset-development';
import Extraction from '../../../content/overview/what-do-we-do/extraction';
import Processing from '../../../content/overview/what-do-we-do/processing';
import ValueAddition from '../../../content/overview/what-do-we-do/value-addition';
import CustomImage from '../../../components/custom-image';
import ScrollPositionAnimation from '../../../components/scrollpositionanimation';

const WhatDoWeDo = () => {
  const sampleData = {
    accordion: [
      { id: 1, title: 'Exploration', source: () => <Exploration /> },
      { id: 2, title: 'Asset Development', source: () => <AssetDevelopment /> },
      { id: 3, title: 'Extraction', source: () => <Extraction /> },
      { id: 4, title: 'Processing', source: () => <Processing /> },
      { id: 5, title: 'Value Addition', source: () => <ValueAddition /> },
    ],
  };
  return (
    <div className="section-what-we-do">
      <div className="container">
        <div className="container-inner">
          <ScrollPositionAnimation targetElement1="anim-1" targetElement2="anim-2">
            <div className="content-row">
              <div className="column-45">
                <div className="left-content">
                  <div className="left-to-right anim-1">
                    <SectionTitle
                      lighttext="WHAT DO WE DO"
                      boldtext="Our value chain"
                      isSectionH1={false}
                    ></SectionTitle>
                    <div className="image-box">
                      <CustomImage
                        className="custom-image"
                        imageName="overview-what-wedo.jpg"
                        alt="What Do We Do"
                        maxWidth="1024"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="column-65">
                <div className="right-content">
                  <div className="accordion-content">
                    <div className="bottom-to-top anim-2">
                      <Accordion data={sampleData.accordion} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ScrollPositionAnimation>
        </div>
      </div>
    </div>
  );
};

export default WhatDoWeDo;
